import { defineComponent as _defineComponent } from 'vue'
import { useModelValue } from '../../../composables/useSyncProp';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'QSearchFiled',
  props: {
    value: { type: String, default: '' },
  },
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props

  

  

  const search = useModelValue(props, emit)

return { __sfc: true,props, emit, search }
}

})